import {faInstagram} from '@fortawesome/free-brands-svg-icons'
import {faPhoneAlt} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import styles from './tMessage.module.css'
import { Link } from "react-router-dom"

export const TMessage = () => {
    return (
        <div>
            
            <div id={styles.tInfo}>

                <p className={styles.Infotxt}>
                    <FontAwesomeIcon className={styles.Ficon} icon={faPhoneAlt}/>+56 9 9748 8665
                </p>
                <Link className={styles.Infotxt} to="/instagram">
                    <p>
                        <FontAwesomeIcon className={styles.Ficon} icon={faInstagram}/>¡Siguenos!
                    </p>
                </Link>
           
            </div>
       
        </div>
    )
}
